module.exports = __webpack_public_path__ + "static/img/icon_quarter.c2006d67.jpg";